import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

let initialState = {
  data: {},
};

export const setSettings = createAsyncThunk(
  "company/settings",
  async (payload) => {
    return payload;
  }
);

const GlobalDataSlice = createSlice({
  name: "companySettings",
  initialState,
  extraReducers: {
    [setSettings.fulfilled]: (state, action) => {
      state.data = { ...action.payload };
    },
  },
});

const { reducer } = GlobalDataSlice;
export default reducer;
